import { useLang } from 'hooks/lang';

import { BugIcon } from 'components/Icons';

import { SideButton } from '../SideButton';

import { CreateBugReportModal } from 'pages/Feedback/components';

export function BugReportButton() {
  const { t } = useLang();

  return (
    <CreateBugReportModal
      trigger={
        <div>
          <SideButton
            label={t('bug-report')}
            icon={<BugIcon size={22} />}
            className={'bg-transparent text-primary-foreground dark:bg-transparent'}
          />
        </div>
      }
    />
  );
}
